class CollectionSelect {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.checkboxes = self.elem.querySelectorAll('[data-collection-select-checkbox]');
        self.badgesContainer = self.elem.querySelector('[data-collection-select-badges]');
        self.badgeTemplate = self.elem.querySelector('[data-collection-select-badge-template]');
        self.limit = self.elem.getAttribute('data-collection-select-limit');
        self.dropdown = self.elem.querySelector('[data-collection-select-dropdown]');
        self.input = self.elem.querySelector('[data-collection-select-input]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.onSpaceOrEnter = self.onSpaceOrEnter.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;

        // Add badges for any checkboxes that are checked on page load
        self.updateBadges();
        self.updateInput();

        // Listen for changes to checkboxes
        [...self.checkboxes].map(checkbox => {
            checkbox.addEventListener('input', evt => {
                // Update badges
                self.updateBadges();
                self.updateInput();
            });
        });

        // Listen for clicks on badges container
        self.badgesContainer.addEventListener('click', evt => {
            if(self.isOpen) {
                // Open dropdown
                self.closeDropdown();
            } else {
                // Close dropdown
                self.openDropdown();
            }
        });

        // Listen for clicks on badges container
        self.badgesContainer.addEventListener('focus', evt => {
            self.addBadgesContainerEventListeners()
        });

        // Stop listening for clicks on badges container
        self.badgesContainer.addEventListener('blur', evt => {
            self.removeBadgesContainerEventListeners()
        });
    }

    uncheckCheckbox(id) {
        let self = this;
        let checkbox = self.elem.querySelector(`[data-collection-select-checkbox="${id}"]`);
        
        checkbox.checked = false;

        self.updateBadges();
        self.updateInput();
    }

    addBadge(id, title) {
        let self = this;
        let badge = self.badgeTemplate.content.cloneNode(true);

        badge.querySelector('[data-collection-select-badge]').setAttribute('data-collection-select-badge', id);
        badge.querySelector('[data-collection-select-badge-text]').textContent = title;
        self.badgesContainer.appendChild(badge);
        
        self.elem.querySelector(`[data-collection-select-badge="${id}"]`).addEventListener('click', evt => {
            evt.stopPropagation();

            self.uncheckCheckbox(id);
        });
    }

    updateBadges() {
        let self = this;
        let checkedCheckboxes = self.elem.querySelectorAll('[data-collection-select-checkbox]:checked');

        // Empty the badges container
        self.badgesContainer.textContent = '';

        // Add a badge for each checked checkbox
        [...checkedCheckboxes].map(checkbox => {
            self.addBadge(
                checkbox.getAttribute('data-collection-select-checkbox'),
                checkbox.getAttribute('data-collection-select-checkbox-title')
            );
        });

        if(self.limit !== null && checkedCheckboxes.length >= parseInt(self.limit)) {
            self.disableSelections();
        }
         else {
            self.enableSelections();
         }
    }

    updateInput() {
        let self = this;
        let checkedCheckboxes = self.elem.querySelectorAll('[data-collection-select-checkbox]:checked');

        let idsArray = [];

        [...checkedCheckboxes].map(checkbox => {
            idsArray.push(checkbox.getAttribute('data-collection-select-checkbox'));
        });

        self.input.value = idsArray.join();
    }

    disableSelections() {
        let self = this;
        let uncheckedCheckboxes = self.elem.querySelectorAll('[data-collection-select-checkbox]:not(:checked)');

        [...uncheckedCheckboxes].map(checkbox => {
            checkbox.disabled = true;
        });
    }

    enableSelections() {
        let self = this;
        let uncheckedCheckboxes = self.elem.querySelectorAll('[data-collection-select-checkbox]:not(:checked)');

        [...uncheckedCheckboxes].map(checkbox => {
            checkbox.disabled = false;
        });
    }

    openDropdown() {
        let self = this;

        self.dropdown.classList.add('is-open');
        self.badgesContainer.setAttribute('aria-expanded', true);
        
        // Add event listeners
        self.addEventListeners();

        self.isOpen = true;
    }

    closeDropdown() {
        let self = this;

        self.dropdown.classList.remove('is-open');
        self.badgesContainer.setAttribute('aria-expanded', false);
        
        // Remove event listeners
        self.removeEventListeners();

        self.isOpen = false;
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        if (evt.target !== self.dropdown && !self.dropdown.contains(evt.target) && evt.target !== self.badgesContainer) {

            // Close the dropdown
            self.closeDropdown();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.closeDropdown();
        }
    }

    addBadgesContainerEventListeners() {
        let self = this;

        // Start listening for escape key press
        document.addEventListener('keydown', self.onSpaceOrEnter);
    }

    removeBadgesContainerEventListeners() {
        let self = this;

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onSpaceOrEnter);
    }

    onSpaceOrEnter(evt) {
        let self = this;

        if (evt.key === "Space" || evt.keyCode === 32 || evt.key === "Enter") {
            evt.preventDefault();

            if(self.isOpen) {
                self.closeDropdown();
            } else {
                self.openDropdown();
            }
        }
    }
}

export default CollectionSelect;
